import { Link } from 'react-router-dom';
import { ArrowRight, Globe, Briefcase, Building2, Zap, Server, Users } from 'lucide-react';
import { solutionCategories } from '../../data/solutionCategories';
import { solutions } from '../../data/solutions';

const CATEGORY_ICONS = {
  'sovereign-cloud': Globe, enterprise: Briefcase, government: Building2,
  'critical-infrastructure': Zap, msps: Server, 'smes-startups': Users
};

export const SolutionsMenu = () => (
  <div className="bg-[#120836] border border-white/10 rounded-2xl shadow-[0_30px_80px_rgba(0,0,0,0.5)] w-[820px] relative overflow-hidden flex" data-testid="solutions-mega-panel">
    <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#F29B3D]/40 to-transparent" />

    {/* Primary solution categories */}
    <div className="flex-1 p-5">
      <p className="text-[#F29B3D] text-[10px] font-extrabold tracking-[2px] uppercase px-3 mb-1.5">
        Solutions
      </p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-0.5">
        {solutionCategories.map((cat) => {
          const Icon = CATEGORY_ICONS[cat.id] || Globe;
          return (
            <Link
              key={cat.id}
              to={cat.href || `/solutions#${cat.id}`}
              data-testid={`dropdown-solution-${cat.id}`}
              className="flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-white/[0.05] transition-colors duration-150 group/item"
            >
              <Icon className="w-4 h-4 text-[#F29B3D]/80 mt-0.5 shrink-0" strokeWidth={1.5} />
              <span className="min-w-0">
                <span className="block text-[13px] font-medium text-[#DCE4EE] group-hover/item:text-white leading-snug transition-colors">{cat.name}</span>
                <span className="block text-[11px] text-[#94A3B8] leading-snug">{cat.audience}</span>
              </span>
            </Link>
          );
        })}
      </div>

      <p className="text-[#F29B3D] text-[10px] font-extrabold tracking-[2px] uppercase px-3 mt-5 mb-2 pt-4 border-t border-white/[0.07]">
        Industries We Support
      </p>
      <div className="flex flex-wrap gap-x-4 gap-y-1.5 px-3">
        {solutions.map((sol) => (
          <Link
            key={sol.id}
            to={`/solutions/${sol.id}`}
            data-testid={`dropdown-industry-${sol.id}`}
            className="text-[12px] text-[#93A5BC] hover:text-white transition-colors"
          >
            {sol.name}
          </Link>
        ))}
      </div>
    </div>

    {/* Side rail — VMware migration */}
    <div className="w-[220px] shrink-0 border-l border-white/[0.07] bg-white/[0.02] p-6">
      <p className="text-[#F29B3D] text-[10px] font-extrabold tracking-[2px] uppercase mb-3">Migration</p>
      <p className="text-white text-[13.5px] font-semibold leading-snug mb-1.5">Moving off VMware?</p>
      <p className="text-[#CBD5E1] text-[12px] leading-relaxed mb-4">
        Migrate virtual machines with near-zero downtime.
      </p>
      <Link
        to="/migrate"
        data-testid="dropdown-migrate-vmware"
        className="flex items-center gap-1.5 text-[#F29B3D] hover:text-white text-[13px] font-semibold transition-colors group/mig"
      >
        Plan your migration
        <ArrowRight className="w-3.5 h-3.5 group-hover/mig:translate-x-0.5 transition-transform" />
      </Link>
    </div>
  </div>
);
